export default __webpack_public_path__ + "static/titilliumweb-bold-webfont-0286865a7126545f19bd279141b277af.woff";